/* eslint-disable no-unused-vars */
/* eslint-disable prefer-template */
import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Carousel } from "react-responsive-carousel";
import Style from "../../assets/css/main.module.css";
import cartCounter from "../../assets/icons/cart-counter.svg";
import minusIcon from "../../assets/icons/minus.svg";
import plusIcon from "../../assets/icons/plus.svg";
import { currencyFormat } from "../../library/currency";
import { addCart, clearCart } from "../../store/features/cartSlice";

export default function Ticket({ item, type }) {
  const { cart } = useSelector((state) => state.cartSlice);
  const [quantity, setQuantity] = useState(1);
  const [showCart, setShowCart] = useState(false);
  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();
  const cartHandler = () => {
    if (cart.length <= 0) {
      dispatch(
        addCart({
          id: item.id,
          name: item.name,
          price: Number(item.price),
          offerPrice: Number(item.offer_price),
          photo: item.photo,
          type,
          quantity,
          park: item.park,
          description: item.description,
        })
      );
    } else {
      const exists = cart.find((cartItem) => cartItem.park === item.park);
      if (exists) {
        dispatch(
          addCart({
            id: item.id,
            name: item.name,
            price: Number(item.price),
            offerPrice: Number(item.offer_price),
            photo: item.photo,
            type,
            quantity,
            park: item.park,
            description: item.description,
          })
        );
      } else {
        setModal(true);
      }
    }
  };
  const destroyCart = () => {
    dispatch(clearCart());
    setModal(false);
  };
  const quantityHandler = (name) => {
    if (name === "increment") {
      setQuantity(quantity + 1);
    }
    if (name === "decrement") {
      const temp = quantity - 1;
      if (temp > 0) {
        setQuantity(temp);
      }
    }
  };
  const [carted, setCarted] = useState(false);
  useEffect(() => {
    const existQuantity =
      cart.find((cartItem) => cartItem.id === item.id && cartItem.type === type)
        ?.quantity || 0;
    if (existQuantity) {
      setCarted(true);
      setQuantity(existQuantity);
    } else {
      setQuantity(1);
      setCarted(false);
    }
  }, [cart, item, type]);
  const cardRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (cardRef.current && !cardRef.current.contains(event.target)) {
        setShowCart(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [cardRef]);

  return (
    <>
      <div
        className="bg-light box-sizing d-flex flex-column"
        style={{ width: "230px", height: "230px" }}
        ref={cardRef}
      >
        <div className="position-relative">
          <Carousel
            showThumbs={false}
            showIndicators={false}
            showStatus={false}
            autoPlay
            infiniteLoop
            showArrows={false}
          >
            {item.photo.map((photo) => (
              <img
                src={photo}
                alt={item.name}
                key={Math.random()}
                style={{
                  width: "100%",
                  // height: "150px",
                  height: showCart ? "100px" : "150px",
                  objectFit: "fill",
                  transition: "height 0.5s ease",
                }}
              />
            ))}
          </Carousel>
          {!showCart && carted && (
            <div
              className="position-absolute"
              style={{ top: "5px", right: "5px" }}
            >
              <div className="position-relative">
                <img src={cartCounter} alt="counter" />
                <p
                  className={`${Style.fw_600} ${Style.fs_16} position-absolute top-50 start-50 translate-middle text-light pt-2`}
                >
                  {quantity}
                </p>
              </div>
            </div>
          )}
        </div>
        {!showCart && (
          <div
            className="d-flex flex-column justify-content-end px-2 pb-2"
            style={{ height: "80px" }}
          >
            <div className="d-flex justify-content-between align-items-end gap-1">
              <div className="d-flex flex-column">
                <div
                  className={`${Style.fw_400} ${Style.fs_16} ${Style.text_primary}`}
                >
                  {item.name.length > 28
                    ? `${item.name.substring(0, 28)}...`
                    : item.name}
                </div>
                <div className={`${Style.fw_350} ${Style.fs_16}`}>
                  {Number(item.offer_price)>0 ? (
                    <>
                      <span className="text-decoration-line-through text-danger">{currencyFormat(item.price)}</span>
                      <span className="ps-3">{currencyFormat(item.offer_price)}</span>
                    </>
                  ) : (
                    <span>{currencyFormat(item.price)}</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        {showCart && (
          <div
            className="d-flex flex-column justify-content-end px-2 pb-2"
            style={{ height: "130px" }}
          >
            <div className="d-flex justify-content-between align-items-end gap-1">
              <div className="d-flex flex-column align-items-center w-100">
                <div
                  className={`w-100 d-flex flex-column align-items-center border-bottom ${Style.border_secondary_500} pb-2`}
                >
                  <div className={`${Style.fw_300} ${Style.fs_14} text-center text-danger w-100`}>
                    {item.description && item.description.length > 29
                      ? `${item.description.slice(0, 29)}...`
                      : item.description}
                  </div>
                </div>
                <div
                  className={`d-flex align-items-center ${Style.fw_400} ${Style.fs_14} ${Style.text_primary} py-2`}
                >
                  <div>Select Quantity</div>
                  <div>
                    <div className="d-flex align-items-center">
                      <div>
                        <button
                          type="button"
                          className={`${Style.bg_none} d-flex align-items-center border-0`}
                          onClick={() => quantityHandler("decrement")}
                        >
                          <img src={minusIcon} alt="minus" />
                        </button>
                      </div>
                      <div
                        className={`${Style.bg_gray_200} ${Style.fw_400} ${Style.fs_14} px-3 py-1`}
                      >
                        {quantity}
                      </div>
                      <div>
                        <button
                          type="button"
                          className={`${Style.bg_none} d-flex align-items-center border-0`}
                          onClick={() => quantityHandler("increment")}
                        >
                          <img src={plusIcon} alt="plus" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <Modal
        show={modal}
        onHide={() => setModal(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-danger">
            You can not add different park tickets
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          In order to add these tickets, we will have to remove the ones added
          from the previous park. Do you wish to continue?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModal(false)}>
            No
          </Button>
          <Button variant="primary" onClick={destroyCart}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
